import { z } from 'zod';

import { SectionDtoScheme } from '~modules/section/model';

export const UserWorkScheme = z.object({
	storeId: z.string(),
	position: z.string(),
	work_place: z.string(),
	position_type: z.string(),
});

export type UserWork = z.infer<typeof UserWorkScheme>;

export const UserDtoScheme = z.object({
	id: z.number().describe('Уникальный идентификатор'),
	section_id: z.number().nullable().describe('Идентификатор участка').optional(),
	section: SectionDtoScheme.nullable().optional().describe('Участок'),
	name: z.string().describe('ФИО'),
	department_id: z.string().describe('Идентификатор подразделения').nullable().optional(),
	organization_id: z.string().describe('Идентификатор организации').nullable().optional(),
	preferred_username: z.string().describe('ФИО или телефон или Email из клоаки'),
	given_name: z.string().describe('Имя из клоаки').nullable().optional(),
	family_name: z.string().describe('Фамилия из клоаки').nullable().optional(),
	work_list: z.array(UserWorkScheme).describe('Список рабочих мест'),
	groups: z.array(z.string()).describe('Список прав').nullable(),
	email: z.string().describe('Email для связи с менеджером подрядчика').nullable().optional(),
	manager_id: z.number().describe('Ссылка на менеджера если привязан').nullable().default(null).optional(),
	num: z.number().describe('Номер по штатному расписанию'),
	num_parent: z.number().optional().describe('Номер руководителя по штатному расписанию'),
	is_fired: z.boolean().describe('Уволен').nullable().default(false).optional(),
	position: z.string().nullable().default(null).optional().describe('Должность'),
});

export type UserDto = z.infer<typeof UserDtoScheme>;

export const UserWithTotalDtoScheme = z.object({
	total: z.number().describe('Кол-во записей'),
	list: z.array(UserDtoScheme).describe('Список пользователей'),
});

export type UserWithTotalDto = z.infer<typeof UserWithTotalDtoScheme>;
